import { isApplicationDeadlinePassed } from "@/features/event/application-deadline";
import type { VolunteerRegistration } from "./_types";

const DISPLAY_DATE = new Intl.DateTimeFormat("en-US", {
  timeZone: "UTC",
  month: "long",
  day: "numeric",
  year: "numeric",
});

export function isVolunteerRegistrationClosed(closeDate: string | undefined, now: number): boolean {
  return isApplicationDeadlinePassed(closeDate, now);
}

export function getVolunteerRegistrationView(registration: VolunteerRegistration, year: number, now: number | null) {
  const closed = now !== null && isVolunteerRegistrationClosed(registration.closeDate, now);
  const pending = Boolean(registration.url) && now === null;
  const open = Boolean(registration.url) && !closed && !pending;
  const statusLabel = closed ? "Closed" : pending ? "Checking…" : open ? "Open" : "TBA";
  const disabledLabel = closed ? "Applications Closed" : pending ? "Checking registration…" : "Registration Link TBA";
  const closeDateLabel = registration.closeDate
    ? DISPLAY_DATE.format(new Date(`${registration.closeDate}T00:00:00Z`))
    : "TBA";

  return {
    open,
    statusLabel,
    disabledLabel,
    closeDateLabel,
    heroDescription: open
      ? `The ${year} application window is open. Explore the departments and requirements, then apply to help thousands of fans have an unforgettable weekend.`
      : closed
        ? `The ${year} application window is closed. Explore the departments and requirements that help thousands of fans have an unforgettable weekend.`
        : `Explore the departments and requirements that help thousands of fans have an unforgettable weekend. Volunteer registration for ${year} is ${pending ? "being checked" : "TBA"}.`,
    ctaEyebrow: `Application Window · ${statusLabel}`,
    ctaTitle: open
      ? `Join the ${year} volunteer team`
      : closed
        ? "Plan ahead for the next volunteer cycle"
        : "Plan ahead for the volunteer application window",
    ctaDescription: open
      ? `Applications for the ${year} convention are open${registration.closeDate ? ` through ${closeDateLabel}` : ""}. Explore the departments and apply through the official volunteer portal.`
      : closed
        ? `Applications for the ${year} convention closed ${closeDateLabel}. Explore the departments now and check back for the next application window.`
        : `Explore the departments now and check back for volunteer registration details for the ${year} convention.`,
  };
}
